<script lang="ts">
  import { onMount } from 'svelte';
  import { formatCurrency } from '../lib/analytics.js';
  import type { Summary } from '../types/transaction';
  import { StatCard } from './common';

  let { summary }: { summary: Summary | null } = $props();

  let totalIncome = $derived(summary?.totalIncome || 0);
  let totalExpenses = $derived(summary?.totalExpenses || 0);
  let totalSavings = $derived(summary?.totalSavings || 0);
  let netBalance = $derived(summary?.netBalance || 0);
  let transactionCount = $derived(summary?.totalTransactions || 0);

  // Budget health state
  let budgetHealth = $state<{
    onTrack: number;
    total: number;
    loading: boolean;
  }>({ onTrack: 0, total: 0, loading: true });

  onMount(async () => {
    // Budget health API disabled until budgets are migrated to storage provider
    // await loadBudgetHealth();
    budgetHealth = { onTrack: 0, total: 0, loading: false };
  });

  async function loadBudgetHealth() {
    // Budget health widget is optional - full budgets available on Budgets page
    // To enable: uncomment the code below
    try {
      const now = new Date();
      const month = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;

      // const { getBudgetStatus } = await import('./lib/storage.js');
      // const data = await getBudgetStatus(month);
      // const allBudgets = [
      //   ...(data.monthly || []),
      //   ...(data.quarterly || []),
      //   ...(data.yearly || [])
      // ];
      //
      // budgetHealth = {
      //   onTrack: allBudgets.filter((b: any) => b.percentage < 90).length,
      //   total: allBudgets.length,
      //   loading: false
      // };

      budgetHealth = { onTrack: 0, total: 0, loading: false };
    } catch (error) {
      console.error('Error loading budget health:', error);
      budgetHealth = { onTrack: 0, total: 0, loading: false };
    }
  }

  function navigateToBudgets() {
    window.location.hash = '#/budgets';
  }
</script>

<div class="dashboard">
  <StatCard
    label="Income"
    value={totalIncome}
    formatter={formatCurrency}
    variant="success"
  />

  <StatCard
    label="Expenses"
    value={totalExpenses}
    formatter={formatCurrency}
    variant="danger"
  />

  {#if totalSavings > 0}
    <StatCard
      label="Savings"
      value={totalSavings}
      formatter={formatCurrency}
      variant="primary"
    />
  {/if}

  <StatCard
    label="Transactions"
    value={transactionCount}
    variant="primary"
  />

  {#if !budgetHealth.loading && budgetHealth.total > 0}
    <StatCard
      label="Budget Health"
      value="{budgetHealth.onTrack} / {budgetHealth.total}"
      subtitle="on track"
      variant="warning"
    />
  {/if}
</div>

<style lang="scss">
  .dashboard {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: var(--spacing-lg);
  }

  @media (max-width: 1024px) {
    .dashboard {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 640px) {
    .dashboard {
      grid-template-columns: 1fr;
      gap: var(--spacing-md);
    }
  }
</style>
